<template>
	<van-pull-refresh
		v-on="$listeners"
		:pull-distance="pullHeight"
		:head-height="headDistance"
		:value="value"
		@input="v => $emit('input', v)"
		class="pull-refresh"
		:class="{ ios: isIOS }"
		ref="vanPullRefresh"
	>
		<template #pulling>
			<van-loading type="spinner" :size="18" />
		</template>

		<template #loading>
			<van-loading type="spinner" :size="18" />
		</template>

		<template #loosing>
			<van-loading type="spinner" :size="18" />
		</template>

		<template #default>
			<slot></slot>
		</template>
	</van-pull-refresh>
</template>

<script>
import hybrid from '@/util/nativeHybrid'

export default {
	name: 'pull-refresh',
	props: {
		pullHeight: {
			type: Number,
			required: true
		},
		value: {
			type: Boolean,
			default: false
		},
		status: {
			type: String,
			default: 'normal'
		}
	},
	computed: {
		isIOS() {
			let osinfo = hybrid.getOSInfo()
			return osinfo && osinfo['device_type'] == 'ios'
		},
		headDistance() {
			return this.pullHeight
		}
	},
	created() {},
	mounted() {
		const fn = this.$refs.vanPullRefresh.setStatus

		const emitter = this.onChange.bind(this)

		this.$refs.vanPullRefresh.setStatus = function(...args) {
			fn(...args)
			emitter({ status: this.status, distance: this.distance })
		}.bind(this.$refs.vanPullRefresh)
	},
	methods: {
		onChange(e) {
			this.$emit('update:status', e.status)
		}
	}
}
</script>

<style lang="scss" scoped>
.pull-refresh {
	::v-deep {
		.van-pull-refresh__head {
			> * {
				position: absolute;
				width: 100%;
				bottom: 0;
			}
		}

		//.van-pull-refresh__track:not(.ios) {
		//  transform: none !important;
		//
		//  .van-pull-refresh__head {
		//    overflow: unset !important;
		//  }
		//}
	}
}
</style>
